module.exports = __webpack_public_path__ + "static/media/jordi@3x.3cfb290b.jpg";